import { APIClient } from '@frontend/api-utils';

export type ProductCountsResponse = Record<string, Record<string, number>>;

export class PackageProductClient extends APIClient {
    public static readonly endpoint = '/package-api/v1';

    public static async fetchProductCounts(accountId: string, productId: string): Promise<ProductCountsResponse> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/products/${productId}/counts`);
        return await this.handleResponse<ProductCountsResponse>(response);
    }
}
